
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 144 144","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M66.06 25.14h37.021V79.8l12 12V25.14c0-6.6-5.4-12-12-12h-42L48.72 25.5l8.52 8.52 8.82-8.88zm62.58 97.261L23.82 17.581l-8.46 8.46 15.72 15.72v67.38c0 6.66 5.4 12 12 12h67.38l9.72 9.72 8.46-8.46zm-85.56-68.52v55.26h55.38l-55.38-55.26z","fill":"#ABABAB"}})])
          )
        }
      }
    